import Constants from "../../config/Constants";
import { sendPOSTRequest } from "../../utils/common_functions";

export const sendRequestGetOfferStatsReports = async (dataToPost) => {
  console.log("sendRequestGetPublishers");
  // console.log(dataToPost.advertisers);
  const url = Constants.APP_SERVER_REPORTING_OFFER_STATS_URL;
  const headersToPost = {
    "Content-type": "application/json;charset=UTF-8",
    Authorization: "Bearer " + dataToPost.accessToken,
  };
  let data = {
    ...dataToPost.data,
  };
  delete data["accessToken"];
  
  sendPOSTRequest(
    url,
    data,
    headersToPost,
    sendRequestGetPublishersReportsSuccessHandler,
    sendRequestGetPublishersReportsErrorHandler
  );

  function sendRequestGetPublishersReportsSuccessHandler(response, request) {
    console.log(
      "🚀 ~ file: CreatePublisher.js:85 ~ sendCreatePublisherFormSubmitResponseSuccessHandler ~ response:",
      response,
      request
    );
    if(Array.isArray(response)){
      dataToPost?.loadingHandler && dataToPost?.loadingHandler(false)
        dataToPost?.dataHander && dataToPost?.dataHander(response)
    }
  }
};



function sendRequestGetPublishersReportsErrorHandler(error, request) {
  console.log(
    "🚀 ~ file: Reports.js:33 ~ sendRequestGetPublishersReportsErrorHandler ~ error:",
    error,
    request
  );
  request?.loadingHandler && request?.loadingHandler(false)
  //   request.history("", { state: { from: "Publisher", type: 'error', message: error.message } });
}


export const sendRequestGetPublisherOfferStatReports = async (dataToPost) => {
  console.log("sendRequestGetPublishers");
  // console.log(dataToPost.advertisers);
  const url = Constants.APP_SERVER_PUBLISHER_OFFER_STATS_URL;
  const headersToPost = {
    "Content-type": "application/json;charset=UTF-8",
    Authorization: "Bearer " + dataToPost.accessToken,
  };
  let data = {
    ...dataToPost.data,
  };
  delete data["accessToken"];
  
  sendPOSTRequest(
    url,
    data,
    headersToPost,
    sendRequestGetPublishersReportsSuccessHandler,
    sendRequestGetPublishersReportsErrorHandler
  );

  function sendRequestGetPublishersReportsSuccessHandler(response, request) {
    console.log(
      "🚀 ~ file: CreatePublisher.js:85 ~ sendCreatePublisherFormSubmitResponseSuccessHandler ~ response:",
      response,
      request
    );
    if(Array.isArray(response)){
      dataToPost?.loadingHandler && dataToPost?.loadingHandler(false)
        dataToPost?.dataHander && dataToPost?.dataHander(response)
    }
  }
};

export const sendRequestGetPublisherOfferDailyStatReports = async (dataToPost) => {
  console.log("sendRequestGetPublishers");
  // console.log(dataToPost.advertisers);
  const url = Constants.APP_SERVER_PUBLISHER_OFFER_DAILY_STATS_URL;
  const headersToPost = {
    "Content-type": "application/json;charset=UTF-8",
    Authorization: "Bearer " + dataToPost.accessToken,
  };
  let data = {
    ...dataToPost.data,
  };
  delete data["accessToken"];
  
  sendPOSTRequest(
    url,
    data,
    headersToPost,
    sendRequestGetPublishersReportsSuccessHandler,
    sendRequestGetPublishersReportsErrorHandler
  );

  function sendRequestGetPublishersReportsSuccessHandler(response, request) {
    console.log(
      "🚀 ~ file: CreatePublisher.js:85 ~ sendCreatePublisherFormSubmitResponseSuccessHandler ~ response:",
      response,
      request
    );
    if(Array.isArray(response)){
      dataToPost?.loadingHandler && dataToPost?.loadingHandler(false)
        dataToPost?.dataHander && dataToPost?.dataHander(response)
    }
  }
};


function sendRequestGetMonthlyRevenueReportsErrorHandler(error, request) {
  console.log(
    "🚀 ~ file: Reports.js:93 ~ sendRequestGetMonthlyRevenueReportsErrorHandler ~ error:",
    error,
    request
  );
  if(request.loadingHandler){
    request.loadingHandler(false)
  }
}

function sendRequestGetMonthlyFinalRevenueReportsErrorHandler(error, request) {
  console.log(
    "🚀 ~ file: Reports.js:93 ~ sendRequestGetMonthlyFinalRevenueReportsErrorHandler ~ error:",
    error,
    request
  );
  if(request.loadingHandler){
    request.loadingHandler(false)
  }
}

function sendRequestGetMonthlyStatusErrorHandler(error, request) {
  console.log(
    "🚀 ~ file: Reports.js:93 ~ sendRequestGetMonthlyStatusErrorHandler ~ error:",
    error,
    request
  );
  if(request.loadingHandler){
    request.loadingHandler(false)
  }
}


export const sendRequestGetMonthlyRevenueReports = async (dataToPost) => {
  console.log("sendRequestGetMonthlyRevenueReports");
  // console.log(dataToPost.advertisers);
  const url = Constants.APP_SERVER_MONTHLY_REVENUE_REPORTS_URL;
  const headersToPost = {
    "Content-type": "application/json;charset=UTF-8",
    Authorization: "Bearer " + dataToPost.accessToken,
  };
  let data = {
    ...dataToPost.data,
  };
  delete data["accessToken"];
  
  sendPOSTRequest(
    url,
    data,
    headersToPost,
    sendRequestGetMonthlyRevenueReportsSuccessHandler,
    sendRequestGetMonthlyRevenueReportsErrorHandler
  );

  function sendRequestGetMonthlyRevenueReportsSuccessHandler(response, request) {
    console.log(
      "🚀 ~ file: CreatePublisher.js:85 ~ sendCreatePublisherFormSubmitResponseSuccessHandler ~ response:",
      response,
      request
    );
    if(Array.isArray(response)){
        dataToPost?.dataHander && dataToPost?.dataHander(response)
    }
  }
};

export const sendRequestGetMonthlyRevenueReportsAdd = async (dataToPost) => {
  console.log("sendRequestGetMonthlyRevenueReportsAdd");
  // console.log(dataToPost.advertisers);
  const url = Constants.APP_SERVER_MONTHLY_REVENUE_REPORTS_ADD_URL;
  const headersToPost = {
    "Content-type": "application/json;charset=UTF-8",
    Authorization: "Bearer " + dataToPost.accessToken,
  };
  let data = {
    ...dataToPost.data,
  };
  delete data["accessToken"];
  
  sendPOSTRequest(
    url,
    data,
    headersToPost,
    sendRequestGetMonthlyRevenueReportsSuccessHandler,
    sendRequestGetMonthlyRevenueReportsErrorHandler
  );

  function sendRequestGetMonthlyRevenueReportsSuccessHandler(response, request) {
    console.log(
      "🚀 ~ file: CreatePublisher.js:85 ~ sendCreatePublisherFormSubmitResponseSuccessHandler ~ response:",
      response,
      request
    );
    if(Array.isArray(response)){
        dataToPost?.dataHander && dataToPost?.dataHander(response)
    }
  }
};


export const sendRequestGetMonthlyRevenueReportsAdmin = async (dataToPost) => {
  console.log("sendRequestGetMonthlyRevenueReportsAdmin");
  // console.log(dataToPost.advertisers);
  const url = Constants.APP_SERVER_MONTHLY_REVENUE_REPORTS_ADMIN_URL;
  const headersToPost = {
    "Content-type": "application/json;charset=UTF-8",
    Authorization: "Bearer " + dataToPost.accessToken,
  };
  let data = {
    ...dataToPost.data,
  };
  data.loadingHandler = dataToPost.loadingHandler
  delete data["accessToken"];
  
  sendPOSTRequest(
    url,
    data,
    headersToPost,
    sendRequestGetMonthlyRevenueReportsAdminSuccessHandler,
    sendRequestGetMonthlyRevenueReportsErrorHandler
  );

  function sendRequestGetMonthlyRevenueReportsAdminSuccessHandler(response, request) {
    console.log(
      "🚀 ~ file: CreatePublisher.js:85 ~ sendCreatePublisherFormSubmitResponseSuccessHandler ~ response:",
      response,
      request
    );
    if(Array.isArray(response)){
        dataToPost?.dataHander && dataToPost?.dataHander(response)
    }
  }
};


export const sendRequestUpdateMonthlyRevenueReportsAdmin = async (dataToPost) => {
  console.log("sendRequestGetMonthlyRevenueReportsAdmin");
  // console.log(dataToPost.advertisers);
  const url = Constants.APP_SERVER_UPDATE_MONTHLY_REVENUE_REPORTS_ADMIN_URL;
  const headersToPost = {
    "Content-type": "application/json;charset=UTF-8",
    Authorization: "Bearer " + dataToPost.accessToken,
  };
  let data = {
    ...dataToPost.data,
  };
  delete data["accessToken"];
  
  sendPOSTRequest(
    url,
    data,
    headersToPost,
    sendRequestGetMonthlyRevenueReportsAdminSuccessHandler,
    sendRequestGetMonthlyRevenueReportsErrorHandler
  );

  function sendRequestGetMonthlyRevenueReportsAdminSuccessHandler(response, request) {
    console.log(
      "🚀 ~ file: CreatePublisher.js:85 ~ sendCreatePublisherFormSubmitResponseSuccessHandler ~ response:",
      response,
      request
    );
    if(Array.isArray(response)){
        dataToPost?.dataHander && dataToPost?.dataHander(response)
    }
  }
};

export const sendRequestUpdateMonthlyFinalRevenueReportsAdmin = async (dataToPost) => {
  console.log("sendRequestGetMonthlyFinalRevenueReportsAdmin");
  // console.log(dataToPost.advertisers);
  const url = Constants.APP_SERVER_UPDATE_MONTHLY_FINAL_REVENUE_REPORTS_ADMIN_URL;
  const headersToPost = {
    "Content-type": "application/json;charset=UTF-8",
    Authorization: "Bearer " + dataToPost.accessToken,
  };
  let data = {
    ...dataToPost.data,
  };
  delete data["accessToken"];
  
  sendPOSTRequest(
    url,
    data,
    headersToPost,
    sendRequestGetMonthlyFinalRevenueReportsAdminSuccessHandler,
    sendRequestGetMonthlyFinalRevenueReportsErrorHandler
  );

  function sendRequestGetMonthlyFinalRevenueReportsAdminSuccessHandler(response, request) {
    console.log(
      "🚀 ~ file: CreatePublisher.js:85 ~ sendCreatePublisherFormSubmitResponseSuccessHandler ~ response:",
      response,
      request
    );
    if(Array.isArray(response)){
        dataToPost?.dataHander && dataToPost?.dataHander(response)
    }else {
      dataToPost?.dataHander && dataToPost?.dataHander(response)
    }
  }
};



export const sendRequestUpdateMonthlyStatusReportsAdmin = async (dataToPost) => {
  console.log("sendRequestUpdateMonthlyStatusReportsAdmin");
  // console.log(dataToPost.advertisers);
  const url = Constants.APP_SERVER_UPDATE_STATUS_REPORTS_ADMIN_URL;
  const headersToPost = {
    "Content-type": "application/json;charset=UTF-8",
    Authorization: "Bearer " + dataToPost.accessToken,
  };
  let data = {
    ...dataToPost.data,
  };
  delete data["accessToken"];
  
  sendPOSTRequest(
    url,
    data,
    headersToPost,
    sendRequestGetMonthlyStatusAdminSuccessHandler,
    sendRequestGetMonthlyStatusErrorHandler
  );

  function sendRequestGetMonthlyStatusAdminSuccessHandler(response, request) {
    console.log(
      "🚀 ~ file: CreatePublisher.js:85 ~ sendCreatePublisherFormSubmitResponseSuccessHandler ~ response:",
      response,
      request
    );
    if(Array.isArray(response)){
      dataToPost?.dataHander && dataToPost?.dataHander(response)
  }else {
    dataToPost?.dataHander && dataToPost?.dataHander(response)
  }
  }
};

export const sendRequestGetPrepingReportsAdmin = async (dataToPost) => {
  console.log("sendRequestGetMonthlyRevenueReportsAdmin");
  // console.log(dataToPost.advertisers);
  const url = Constants.APP_SERVER_PREPING_REPORTS_ADMIN_URL;
  const headersToPost = {
    "Content-type": "application/json;charset=UTF-8",
    Authorization: "Bearer " + dataToPost.accessToken,
  };
  let data = {
    ...dataToPost.data,
  };
  data.loadingHandler = dataToPost.loadingHandler
  delete data["accessToken"];
  
  sendPOSTRequest(
    url,
    data,
    headersToPost,
    sendRequestGetPrepingReportsAdminSuccessHandler,
    sendRequestPrepingReportsErrorHandler
  );

  function sendRequestGetPrepingReportsAdminSuccessHandler(response, request) {
    console.log(
      "🚀 ~ file: CreatePublisher.js:85 ~ sendRequestGetPrepingReportsAdminSuccessHandler ~ response:",
      response,
      request
    );
    if(Array.isArray(response)){
        dataToPost?.dataHander && dataToPost?.dataHander(response)
    }
  }
};

function sendRequestPrepingReportsErrorHandler(error, request) {
  console.log(
    "🚀 ~ file: Reports.js:93 ~ sendRequestPrepingReportsErrorHandler ~ error:",
    error,
    request
  );
  if(request.loadingHandler){
    request.loadingHandler(false)
  }
}

export const sendRequestGetPrepingDetailsReportsAdmin = async (dataToPost) => {
  console.log("sendRequestGetMonthlyRevenueReportsAdmin");
  // console.log(dataToPost.advertisers);
  const url = Constants.APP_SERVER_PREPING_DETAILS_REPORTS_ADMIN_URL;
  const headersToPost = {
    "Content-type": "application/json;charset=UTF-8",
    Authorization: "Bearer " + dataToPost.accessToken,
  };
  let data = {
    ...dataToPost.data,
  };
  data.loadingHandler = dataToPost.loadingHandler
  delete data["accessToken"];
  
  sendPOSTRequest(
    url,
    data,
    headersToPost,
    sendRequestGetPrepingDetailsReportsAdminSuccessHandler,
    sendRequestPrepingDetailsReportsErrorHandler
  );

  function sendRequestGetPrepingDetailsReportsAdminSuccessHandler(response, request) {
    console.log(
      "🚀 ~ file: CreatePublisher.js:85 ~ sendRequestGetPrepingDetailsReportsAdminSuccessHandler ~ response:",
      response,
      request
    );
    if((response)){
        dataToPost?.dataHander && dataToPost?.dataHander(response)
    }
  }
};

function sendRequestPrepingDetailsReportsErrorHandler(error, request) {
  console.log(
    "🚀 ~ file: Reports.js:93 ~ sendRequestPrepingDetailsReportsErrorHandler ~ error:",
    error,
    request
  );
  if(request.loadingHandler){
    request.loadingHandler(false)
  }
}